import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useRouteStatus from '../../../hooks/useRouteStatus';
import useSession from '../../../hooks/useSession';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { payNowUrl } from '../../../lib/constants/SiteVariables';
import { updateParent } from '../../../lib/utils/modal';
import PayNowOption from '../../shared/PayNowOption';
import ProgressBars from '../../shared/ProgressBars';
import ReturnToMerchant from '../../shared/ReturnToMerchant';
import Support from '../../shared/Support';

export default function Declined({ location }) {
  const [session, sessionActions] = useSession();
  const merchant = useSessionEntity('merchant');
  const cart = useSessionEntity('shopping_cart');

  const redirect = () => {
    if (session.mode === 'modal') {
      updateParent('complete', cart ? cart.cancel_url : '');
    } else {
      if (cart && cart.cancel_url && session.strategy !== 'async') {
        window.location.href = cart.cancel_url;
      } else if (merchant !== undefined) {
        window.location.href = merchant.url;
      } else {
        window.location.href = '/';
      }
    }
  };

  const handlePayNowContinue = () => {
    if (payNowUrl) {
      window.location.href = payNowUrl;
    }
  };

  const showPayNowOption = Boolean(
    cart &&
      merchant &&
      merchant.supports_pay_now &&
      merchant.supports_pay_now_on_decline
  );

  useRouteStatus(location);

  useEffect(() => {
    sessionActions.finish();
  }, []);

  return (
    <div role="main" className="mx-6 sm:mx-auto">
      <ProgressBars />
      <div className="my-4 flex items-center">
        <span className="fa-layers fa-fw text-5xl">
          <FontAwesomeIcon
            icon="square"
            className="text-background-error !mx-0"
          />
          <FontAwesomeIcon
            icon={['far', 'heart-crack']}
            className="text-error text-3xl !mx-1.5"
          />
        </span>
        <div className="text-2xl sm:text-4xl font-extrabold">We're sorry</div>
      </div>
      <p className="font-semibold text-lg tracking-wide mb-3 sm:mb-6">
        Your application was not approved.
      </p>
      <div className="tracking-wide mb-6 font-light sm:text-lg">
        You'll receive an email momentarily with further details, including how
        to address any concerns.
      </div>

      {showPayNowOption && <PayNowOption onContinue={handlePayNowContinue} />}

      <div className="my-4 sm:my-10">
        <ReturnToMerchant
          merchant={merchant}
          redirect={redirect}
          asButton={true}
        />
      </div>
      <Support declined={true} />
    </div>
  );
}
